import { PATH_ROUTING } from './../../shared/enums/routing-enums';
export class NavItem {
    id: number;
    display: string;
    icon: string;
    router: string;
    type: RoutingItemTypeEnum;
    isActive: boolean;
    childs?: ChildItem[];
}

export enum RoutingItemTypeEnum {
    LINK = 0,
    DROPDOWN = 1
}

export class ChildItem {
    id: number;
    display: string;
    router: string;
    isActive: boolean;
    childs?: ChildItem[];
}

export enum USERTYPE {
    INTERNAL_USER = 'internal_user',
    SUPPLIER_USER = 'supplier'
}
